import React, { useState } from 'react';
import { Icon } from '../icon/icon.tsx';
import { classList } from '../../../utils/string.ts';

type DropdownProps = {
  options: { value: string; label: string }[];
  onChange?: (selectedOption: string) => void;
  onClick?: () => void;
  selectedOption?: string;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  name?: string;
};

type DropdownFilterProps = {
  className?: string;
  activeFilterCount?: number;
};

export const Dropdown: React.FC<DropdownProps> = ({
  onChange,
  options,
  selectedOption = '',
  className = '',
  containerClassName = '',
  disabled = false,
  name = undefined
}) => {
  const [selected, setSelected] = useState(selectedOption);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelected(value);
    onChange?.(value);
  };

  return (
    <div className={`relative flex ${containerClassName}`}>
      <select
        value={selected}
        onChange={handleChange}
        className={`bg-sk-grey-200 text-sk-blue-500 active:bg-sk-grey-500 flex-grow cursor-pointer appearance-none rounded-lg py-2.5 pr-9 pl-4 text-sm disabled:pointer-events-none disabled:cursor-default disabled:opacity-50 ${className}`}
        disabled={disabled}
        name={name}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <i
        className={`ic-dropdown ${disabled ? 'opacity-50' : ''} pointer-events-none absolute top-1/2 right-2 -translate-y-1/2 transform text-2xl`}
      ></i>
    </div>
  );
};

export const DropdownSorting: React.FC<DropdownProps> = ({
  onChange,
  onClick,
  options,
  selectedOption = '',
  className = '',
  disabled = false
}) => {
  const [selected, setSelected] = useState(selectedOption);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelected(value);
    onChange?.(value);
  };

  return (
    <div className="relative inline-block h-fit">
      <select
        value={selected}
        onChange={handleChange}
        onClick={onClick}
        className={`bg-sk-grey-200 text-sk-blue-500 active:bg-sk-grey-500 cursor-pointer appearance-none rounded-full py-1.5 pr-9 pl-4 text-sm disabled:pointer-events-none disabled:cursor-default disabled:opacity-50 ${className}`}
        disabled={disabled}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <i
        className={`ic-dropdown ${disabled ? 'opacity-50' : ''} pointer-events-none absolute top-1/2 right-2 -translate-y-1/2 transform text-2xl`}
      ></i>
    </div>
  );
};

export const DropdownFilter: React.FC<DropdownFilterProps> = ({
  className = '',
  activeFilterCount = 0
}) => (
  <div
    className={classList(
      'bg-sk-grey-200 active:bg-sk-grey-500 inline-flex cursor-pointer appearance-none flex-row items-center rounded-full py-1 pr-2 pl-4 text-sm',
      className
    )}
  >
    <span className="pr-1">Filter</span>
    {activeFilterCount > 0 && (
      <div className="bg-sk-red-500 text-sk-grey-0 inline-grid h-4 w-4 place-items-center rounded-full text-xs">
        {activeFilterCount}
      </div>
    )}
    <Icon name="dropdown" className="text-2xl" />
  </div>
);
